import { parseNumber } from '@/helpers/validators.js'

export const price1Validation = (isFranchise, isMariaCampaign) => (value, vm) => {
  // Supercampaign allows not having both prices
  if (isMariaCampaign && !value && !vm.price_2) return true
  if (isFranchise) return true
  if (!value || value < 0) return false
  if (!vm.price_2) return value > 0
  return value >= vm.price_2
}

export const price2Validation = (isFranchise, isMariaCampaign) => (value, vm) => {
  // Supercampaign allows not having both prices
  if (isMariaCampaign && !value && !vm.price_1) return true
  if (!value || value < 0) return false
  return value <= vm.price_1
}

export const eansValidation = (eans, product) => {
  if (product.products) return true
  return eans.length
}

export const percentageDiscountValidation = (percentage_discount, product) => {
  if (!percentage_discount) return false

  return true
}

export const cashbackPercentageValidation = (percentage_discount, product) => {
  if (!percentage_discount) return false

  return true
}

export const takeAndPayValidation = (value, product) => {
  const take = parseNumber(product.take, 'int')
  const pay = parseNumber(product.pay, 'int')

  if (!take || !pay) return false

  return take > pay
}

export const minMaxPerClientValidation = (value, product) => {
  const min = product.minimum_per_client
  const max = product.maximum_per_client

  if (!min || !max) return true

  return max >= min
}

export const minMaxPerClientValidationNextbuy = (value, product) => {
  const min = product.minimum_per_client
  const max = product.max_coupons

  if (min && max) return true
  return false
}
